/**
 * Escapes quotes and backslashes so strings can be safely embedded in JSON.
 */
export const escapeJsonString = (str = "") =>
  str?.replace(/\\/g, "\\\\").replace(/"/g, '\\"');

/**
 * Quick JSON validation to avoid try/catch spam throughout the component.
 */
export const isValidJSON = (value) => {
  if (typeof value !== "string") return false;
  try {
    JSON.parse(value);
    return true;
  } catch (_error) {
    return false;
  }
};

/**
 * Filters messages for the current workitem so history rendering stays scoped.
 */
export const filterByLatestWorkitemId = (messages = [], currentWorkitemId) => {
  if (!Array.isArray(messages) || messages.length === 0) {
    return [];
  }

  const latestWorkitemId = currentWorkitemId || messages[0]?.workitemId;
  if (!latestWorkitemId) {
    return [];
  }

  return messages.filter(
    (msg) => msg?.workitemId && msg.workitemId === latestWorkitemId
  );
};

/**
 * Removes near-duplicate messages (within a tolerance window) while preserving order.
 */
export const removeDuplicateMessages = (messages = [], toleranceMs = 1000) =>
  messages
    .slice()
    .reverse()
    .filter((message, index, self) => {
      const currentTimestamp = Number(message?.message?.sentTimestamp);
      const firstIndex = self.findIndex((candidate) => {
        if (!candidate?.message || !message?.message) return false;
        const candidateTimestamp = Number(candidate.message.sentTimestamp);
        const textMatches = candidate.message.text === message.message.text;
        const withinTolerance =
          Math.abs(candidateTimestamp - currentTimestamp) <= toleranceMs;
        return textMatches && withinTolerance;
      });

      return index === firstIndex;
    })
    .reverse();

